import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LocalStorageService } from 'src/app/modules/local-storage/local-storage.module';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable()
export class MotdService {
  private _loggedIn = new BehaviorSubject<Boolean>(false);
  public get loggedIn(): BehaviorSubject<Boolean> {
    return this._loggedIn;
  }

  private _user = new BehaviorSubject(null);
  public get user(): BehaviorSubject<any> {
    return this._user;
  }

  constructor(
    private localStorageService: LocalStorageService,
    private router: Router,
    private authService: AuthService,
    private httpClient: HttpClient) {

    if (this.authService.isAuthenticated()) {
      if (this.authService.user) {
        this._user.next(this.authService.user);
        setTimeout(() => this._loggedIn.next(true));
      } else {
        this.logout(true);
      }
    }
  }

  public logout(force = false) {
    if (this._loggedIn.getValue() || force) {
      this.router.navigate(['auth/logout']);
    }
  }

  public getAllMotd(skip: number, take: number) {
    return this.httpClient.get(`${environment.resource_api}motd/active?skip=${skip}&take=${take}`,
        {headers: new HttpHeaders({'Authorization': this.localStorageService.get('access-token')})});
  }
}
